import { Menu } from "@mantine/core";
import { IconCheck, IconSortAscending, IconSortDescending } from "@tabler/icons-react";
import type { NameSortMode } from "./nameSorting";

type NameSortMenuItemsProps = {
  currentMode?: NameSortMode;
  showCheck?: boolean;
  onModeChange: (mode: NameSortMode) => void;
};

const menuItems: Array<{ mode: NameSortMode; label: string; direction: "asc" | "desc" }> = [
  { mode: "firstNameAsc", label: "First name asc", direction: "asc" },
  { mode: "firstNameDesc", label: "First name desc", direction: "desc" },
  { mode: "surnameAsc", label: "Surname asc", direction: "asc" },
  { mode: "surnameDesc", label: "Surname desc", direction: "desc" },
];

export function NameSortMenuItems({ currentMode, showCheck = true, onModeChange }: NameSortMenuItemsProps) {
  return (
    <>
      {menuItems.map((item) => {
        const Icon = item.direction === "asc" ? IconSortAscending : IconSortDescending;

        return (
          <Menu.Item
            key={item.mode}
            onClick={() => onModeChange(item.mode)}
            leftSection={<Icon size={15} />}
            rightSection={showCheck && currentMode === item.mode ? <IconCheck size={15} /> : undefined}
          >
            {item.label}
          </Menu.Item>
        );
      })}
    </>
  );
}
